<template>     

  <nav-bar :createAction="true" @create="createPatient" />

  <main-container>

    <empty-container>
      <search-input @search="patientStore.filterPatients" />         
    </empty-container>
    <div v-if="toastView" style="width: 100%; padding: 8px; padding-bottom: 12px;">
      <div ref="el" class="toast" role="alert" aria-live="assertive" aria-atomic="true" data-bs-autohide="false" style="background: rgba(255, 179, 0, 0.8); width: 100%;">
        <div class="toast-body" style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
          <span style="font-weight: 600; text-align: center;">Para abrir relatos de pacientes, basta tocar no nome!</span>
          <button type="button" @click="closeToast()" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
      </div>
    </div>

    <main-container>             

    <accordion-list class="py-2" v-if="patientStore.patients.length > 0">
      <accordion-item v-for="obj in patientStore.patients" :key="obj.id" :id="obj.id">          
        <template v-slot:title>
          <div v-on:click="getPatientReports(obj.id)" style="width: 80%; height: 100%;">
            <h5 class="mb-1 fw-bold">{{ obj.name }}</h5>
          </div>
          <div v-if="obj.unreadReports > 0">
            <small style="cursor: pointer; padding-right: 15px;" title="Relatos não lidos" class="mb-0 blue">{{obj.unreadReports}}</small>
          </div>     
        </template>
        <template v-slot:body>
          <div class="text-nowrap" style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding-left: 4px; gap: 10px;">
            <div style="width: 100%; gap: 10px; display: flex; flex-direction: column;">
              <div v-on:click="getPatientReports(obj.id)" class="button-item-accordion">
                <font-awesome-icon title="Visualizar Relatos" icon="newspaper" class="pointer"/>
                <span style="font-size: small;">Acessar Relatos</span>
              </div>
            </div>
            <div style="display: flex; flex-direction: row; width: 100%; gap: 10px;">
              <div style="width: 100%; gap: 10px; display: flex; flex-direction: column;">
                <div v-on:click="updatePatient(obj.id, $event)" class="button-item-accordion">
                  <font-awesome-icon title="Editar Paciente" icon="edit" class="pointer" />
                  <span style="font-size: small;">Editar</span>
                </div>
                <div v-on:click="getIndicators(obj.id, $event)" class="button-item-accordion">
                  <font-awesome-icon title="Ver Indicadores" icon="chart-simple" class="pointer" />
                  <span style="font-size: small;">Indicadores</span>
                </div>
              </div>
              <div style="width: 100%; gap: 10px; display: flex; flex-direction: column;">
                <div v-on:click="getPatientSchedulings(obj.id, $event)" class="button-item-accordion">
                  <font-awesome-icon title="Ver Agendamentos" icon="calendar" class="pointer" />
                  <span style="font-size: small;">Agendamentos</span>
                </div>
                <div v-on:click="getMedicalRecords(obj.id, $event)" class="button-item-accordion">
                  <font-awesome-icon title="Ver Prontuários" icon="book-medical" class="pointer"/>
                  <span style="font-size: small;">Ver Prontuários</span>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="d-flex w-100 justify-content-between">
            <div>       
            </div>
          </div>
          </div>
        </template>
      </accordion-item>                         
    </accordion-list>
    <list-group class="py-2" v-else>
      <list-item class="list-group-item list-group-item-action" >
        <template v-slot:title>
          <h5 class="mb-1">Nenhum Paciente encontrado!</h5>          
        </template>          
      </list-item>                         
    </list-group>      
  </main-container>  
  </main-container>
  <bottom-bar />
</template>

<script>
import { usePatientStore } from "../../store/patient";
import { useUserStore } from '../../store/user';
import { Toast } from "bootstrap";
import { ref } from "vue";
import SearchInput from "../../components/Inputs/SearchInput.vue";
import EmptyContainer from "../../components/Container/EmptyContainer.vue";

export default {
  name: 'PatientsListView',  
  inject:["mySpinner"],
  components: {
    SearchInput,
    EmptyContainer
  },
  setup() {    
    const patientStore = usePatientStore();
    const userStore = useUserStore();
    const localStorageToast = localStorage.getItem("patientToastVisibility");
    const toastVisibility = localStorageToast == null ? true : false;
    let toastView = ref(toastVisibility);
    return { patientStore, userStore, toastView}
  },
  async mounted() {                
    this.mySpinner.loading = true;
    await this.patientStore.getPatients(this.userStore.getUser.clinicId);
    this.mySpinner.loading = false;
    var toast = new Toast(this.$refs.el);
    toast.show();
  },     
  methods: {   
    createPatient() {
      this.$router.push("/patients/create")
    },
    updatePatient(id, event) {
      event.stopPropagation();     
      this.patientStore.targetPatientById(id);        
      this.$router.push(`/patients/${id}`);
    },
    getIndicators(id, event) {
      event.stopPropagation();
      this.patientStore.targetPatientById(id);
      this.$router.push(`/patients/${id}/indicators`);
    },
    getPatientSchedulings(id, event) {
      event.stopPropagation();
      this.patientStore.targetPatientById(id);
      this.$router.push(`/patients/${id}/schedulings`);
    },
    getPatientReports(id) {
      this.patientStore.targetPatientById(id);
      this.$router.push(`/patients/${id}/reports`)
    },
    getMedicalRecords(id, event) {
      event.stopPropagation();
      this.patientStore.targetPatientById(id);
      this.patientStore.getPatientMedicalRecords(id);
      this.$router.push(`/patients/${id}/records`);
    },
    searchPatients() {

    },           
    mailTo(email, event) {
      event.stopPropagation();
      window.location.href = `mailto:${email}`;
    },
    closeToast() {
      setTimeout(() => {
        const toastVisibility = false;
        this.toastView = toastVisibility;
        localStorage.setItem("patientToastVisibility", toastVisibility);
      }, 200);
    }
  },    
}
</script>

<style lang="css" scoped>
  @import'../../assets/css/_colors';
  @import'../../assets/css/_patients';

  .button-item-accordion{
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      padding: 5px;
      border: 1px solid gray;
      border-radius: 5px;
    }
</style>
